import React, {FC, ReactElement, useEffect} from 'react';
import './Icon.scss';
import styled from 'styled-components';

type iconProps = {
    icon: any,
    fontSize: string,
    color: string,
    horizontalAlignment: string,
    isLinkActive: boolean,
    linkUrl: string,
    linkAnalyticEvent: string,
    isOpenLinkInNewTab: boolean,
    anchorName:string,
    anchorTrigger: string,
    selectedLinkType: string|null
}

type iconWrapperProps = {
    horizontalAlignment: string,
}
type iconElementProps = {
    fontSize: string,
    color: string
}
const IconWrapper = styled.div<iconWrapperProps>`
&.iconWrapper {
  justify-content: ${props => props.horizontalAlignment || 'inherit'};
}
`;

const IconElement = styled.span<iconElementProps>`
&.material-icons {
    font-size: ${props => props.fontSize + 'px' || '24px'} !important;
    color: ${props => props.color || 'inherit'};
}
`;

const Icon: FC<iconProps> = ({...props}): ReactElement => {

    if ((props.isLinkActive && !props.selectedLinkType) || props.selectedLinkType === 'hyperlink') {
        return (
            <IconWrapper className={'iconWrapper'} horizontalAlignment={props.horizontalAlignment} data-analytics-click-event={props.linkAnalyticEvent}>
                <a className={'iconLink'} href={props.linkUrl} target={props.isOpenLinkInNewTab ? '_blank' : '_self'}>
                    <div className="icon-container">
                        <IconElement className="material-icons" fontSize={props.fontSize} color={props.color}>{props.icon}</IconElement>
                    </div>
                </a>
            </IconWrapper>
        );
    } else {
        return (
            <IconWrapper className={'iconWrapper'} horizontalAlignment={props.horizontalAlignment}>
                <div className="icon-container">
                    <IconElement className="material-icons" fontSize={props.fontSize} color={props.color}>{props.icon}</IconElement>
                </div>
            </IconWrapper>
        );
    }
};

let settings:any;
let SettingsData;
const environmentLink:any = window.getEnvironmentLink();
try {
    SettingsData = require('../../../settings-data').default;
    // do stuff
} catch (ex) {
    SettingsData = null;
}
if(SettingsData) {
    const settingsClass = new SettingsData();
    const allSettings = settingsClass.getAllSettings();
    settings = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            },
        ],
        [//group
            {
                settingName: 'AddIcon',
                isMainSettings: true
            },
        ],
        [//group
            {
                settingName: 'Size',
                controls: [
                    {
                        controlName: 'Slider',
                        title: 'Size',
                        property: 'fontSize',
                        defaultValue: 70,
                        suffix: 'px',
                        min: 12,
                        max: 150
                    }
                ],
            },
            {
                settingName: 'BackgroundColor',
                controls: [
                    {
                        controlName: 'CustomColors',
                        property: 'color',
                        title: 'Icon Color',
                        defaultValue: '#fff',
                    },
                ],
            }
        ],
        [
            {
                settingName: 'Link',
            },
            {
                settingName: 'Anchor',
            }
        ]
    ];
}

const options = [
    {
        name:'change',
        title: 'Change',
        icon: environmentLink + '/assets/images/Options/icon.svg',
        action: 'setActiveSetting',
        settingTitle: 'Icon'
    },
    {
        name:'size',
        title: 'Size',
        icon: environmentLink + '/assets/images/Options/size.svg',
        action: 'setActiveSetting',
        settingTitle: 'Size'
    }
]

export default {
    Icon,
    settings,
    options,
    label: 'Icon'
};


